import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={16}
    height={26}
    viewBox="0 0 16 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3805 12.7344L2.88115 0.234375L0.619385 2.49694L10.8569 12.7345L0.619385 22.972L2.88115 25.2344L15.3805 12.7344Z"
      fill="black"
    />
  </svg>
);
export default SVGComponent;
